export default __webpack_public_path__ + "static/media/previous.7ec937a5.svg";